import React from 'react'
import styled from '@emotion/styled'
import { COLORS } from 'parameters/index'
import fionaLogo from '../assets/fiona-logo.inline.svg'
import Link from 'next/link'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'

const SimpleHeader = ({}): JSX.Element => (
	<SimpleWrapper>
		<Link passHref href="/" legacyBehavior>
			<ImageWrapper>
				<InlineSvg src={fionaLogo} />
			</ImageWrapper>
		</Link>
	</SimpleWrapper>
)

export default SimpleHeader

const ImageWrapper = styled.a`
	width: 93px;
`

const SimpleWrapper = styled.div`
	width: 100%;
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	height: 80px;
	background-color: ${COLORS.KSU_PURPLE};
	display: flex;
	align-items: center;
	justify-content: center;
`
